var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgStoryboardIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 37.163,
    height: 37.163,
    viewBox: "0 0 37.163 37.163",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_217",
    "data-name": "Rectangle 217",
    width: 37.163,
    height: 37.163,
    transform: "translate(0 0)",
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_322",
    "data-name": "Group 322",
    transform: "translate(-10 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_321",
    "data-name": "Group 321",
    transform: "translate(10)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_163",
    "data-name": "Path 163",
    d: "M37.163,18.581A18.581,18.581,0,1,1,18.582,0,18.581,18.581,0,0,1,37.163,18.581",
    fill: "#0cf"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_164",
    "data-name": "Path 164",
    d: "M8.283,18.592V9.072c0-.7.3-1,1-1q9.294,0,18.589,0c.717,0,1.008.294,1.008,1.015q0,9.492,0,18.985c0,.714-.3,1.012-1.013,1.012H9.305c-.732,0-1.022-.293-1.022-1.031V18.592M28.039,8.918H9.134V28.237h18.9Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_165",
    "data-name": "Path 165",
    d: "M23.118,14.259q-1.767,0-3.534,0c-.472,0-.6-.124-.6-.594q0-1.685,0-3.369c0-.448.134-.58.581-.58h7.1c.431,0,.562.131.563.566q0,1.712,0,3.424c0,.42-.13.551-.547.552q-1.781,0-3.562,0",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_166",
    "data-name": "Path 166",
    d: "M23.117,19.192h3.534c.455,0,.577.123.578.579q0,1.7,0,3.4c0,.435-.131.568-.56.568H19.544c-.411,0-.554-.141-.555-.551q0-1.726,0-3.452c0-.4.138-.538.538-.539,1.2,0,2.393,0,3.59,0",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_167",
    "data-name": "Path 167",
    d: "M14.017,23.736H10.511c-.451,0-.576-.126-.576-.58q0-1.7,0-3.4c0-.441.123-.566.56-.567q3.561,0,7.124,0c.416,0,.554.136.555.55q0,1.727,0,3.452c0,.394-.147.539-.539.539q-1.809,0-3.618,0",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_168",
    "data-name": "Path 168",
    d: "M14.045,14.259q-1.767,0-3.534,0c-.454,0-.576-.123-.577-.579q0-1.7,0-3.4c0-.437.13-.568.56-.568h7.124c.412,0,.555.141.556.551q0,1.727,0,3.452c0,.4-.14.538-.539.539-1.2,0-2.393,0-3.59,0",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_169",
    "data-name": "Path 169",
    d: "M14.028,17.959c-1.066,0-2.131,0-3.2,0-.335,0-.546-.218-.479-.492a.432.432,0,0,1,.481-.333h6.31a1.225,1.225,0,0,1,.3.024.4.4,0,0,1-.055.8,3.842,3.842,0,0,1-.416.007H14.028",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_170",
    "data-name": "Path 170",
    d: "M23.092,17.959q-1.6,0-3.2,0c-.3,0-.473-.137-.484-.38a.381.381,0,0,1,.318-.425,1.21,1.21,0,0,1,.276-.02h6.2c.065,0,.13,0,.194,0a.417.417,0,0,1,.42.427.408.408,0,0,1-.446.4c-1.093,0-2.187,0-3.28,0",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_171",
    "data-name": "Path 171",
    d: "M14.074,26.616h3.085a1.269,1.269,0,0,1,.276.015.4.4,0,0,1,0,.789,1.422,1.422,0,0,1-.277.015h-6.2a1.5,1.5,0,0,1-.277-.013.378.378,0,0,1-.331-.414.373.373,0,0,1,.336-.381,1.6,1.6,0,0,1,.277-.012h3.113",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_172",
    "data-name": "Path 172",
    d: "M23.121,27.436H20.008a1.334,1.334,0,0,1-.276-.014.4.4,0,0,1,0-.79,1.143,1.143,0,0,1,.249-.015h6.28a1.03,1.03,0,0,1,.249.017.342.342,0,0,1,.3.4.807.807,0,0,1-.3.378c-.065.051-.2.023-.3.023H23.121",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_173",
    "data-name": "Path 173",
    d: "M12.208,24.965c.444,0,.888,0,1.332,0,.323,0,.515.16.512.416s-.194.411-.494.412q-1.359.006-2.719,0c-.306,0-.49-.159-.5-.407s.185-.42.5-.421c.454,0,.907,0,1.36,0",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_174",
    "data-name": "Path 174",
    d: "M12.214,15.493c.455,0,.909,0,1.364,0,.289,0,.466.157.473.4a.419.419,0,0,1-.452.425q-1.406.01-2.811,0a.412.412,0,1,1,.007-.82c.473-.006.946,0,1.419,0",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_175",
    "data-name": "Path 175",
    d: "M21.253,15.493c.464,0,.927,0,1.391,0,.293,0,.459.154.462.4a.406.406,0,0,1-.452.419q-1.392.01-2.782,0a.408.408,0,0,1-.462-.41c0-.259.168-.411.48-.413.454,0,.909,0,1.363,0",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_176",
    "data-name": "Path 176",
    d: "M21.245,25.8c-.445,0-.89,0-1.336,0-.325,0-.506-.164-.5-.43s.181-.4.5-.4q1.35,0,2.7,0c.316,0,.491.143.5.4s-.175.428-.5.431c-.454,0-.909,0-1.363,0",
    fill: "#fff"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStoryboardIcon);
export default __webpack_public_path__ + "static/media/storyboardIcon.9325b1d527e3c6a6ef206b4739fd53bf.svg";
export { ForwardRef as ReactComponent };